<template>
  <div class="container-fluid h-100">
    <div class="content-register" id="content1-register">
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100"
      >
        <div class=" col-12 col-md-12 col-lg-6 col-xl-7 col-sm-12  ">
          <div class="row p-row mt-3">
            <div class="col-12 small-info">
              <small
                >Recuerda que los datos marcados con (*) son obligatorios</small
              > 
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Tipo de documento *</h6>
                <div class="input-group mb-3 ">
                  <select
                    v-model="dataUser.document_type_id"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.documentType }"
                    id="exampleFormControlSelect1"
                    placeholder="Tipo de documento *"
                    disabled
                  >
                    <option value="0" disabled selected
                      >Tipo de documento *</option
                    >
                    <option
                      v-for="(item, i) in listTypeDocuments"
                      :key="'td' + i"
                      :value="item.id"
                      class="color-option"
                      >{{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.documentType"
                  class="text-danger float-left small error-danger"
                  >{{ errors.documentType }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Número de documento *</h6>
                <div class="input-group  mb-3">
                  <input
                    v-model="dataUser.document_number"
                    type="text"
                    class="form-control color-input"
                    :class="{ 'is-danger': errors.documentNumber }"
                    aria-label="document"
                    placeholder="Número de documento * "
                    aria-describedby="basic-addon1"
                    disabled
                  />
                </div>
                <span
                  v-if="errors.documentNumber"
                  class="text-danger float-left small error-danger"
                  >{{ errors.documentNumber }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Nombres *</h6>
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.name }"
                    v-model="dataUser.name"
                    type="text"
                    class="form-control color-input"
                    aria-label="name"
                    placeholder="Nombres *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.name"
                  class="text-danger float-left small error-danger"
                  >{{ errors.name }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Apellidos *</h6>
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.lastName }"
                    v-model="dataUser.last_name"
                    type="text"
                    class="form-control color-input"
                    aria-label="lastName"
                    placeholder="Apellidos *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.lastName"
                  class="text-danger float-left small error-danger"
                  >{{ errors.lastName }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Departamento *</h6>
                <div class="input-group  mb-3">
                  <select
                    v-model="dataUser.state_id"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.state }"
                    id="exampleFormControlSelect1"
                  >
                    <option disabled value="0" selected>Departamento *</option>
                    <option
                      v-for="(item, i) in listDocuments"
                      :value="item.id"
                      class=" color-option"
                      :key="'st' + i"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.state"
                  class="text-danger float-left small error-danger"
                  >{{ errors.state }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Ciudad *</h6>
                <div class="input-group mb-3">
                  <select
                    v-model="dataUser.city_id"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.cityId }"
                    id="exampleFormControlSelect1"
                  >
                    <option value="0" disabled selected>Ciudad *</option>
                    <option
                      v-for="(item, i) in listCities"
                      :key="'ci' + i"
                      :value="item.id"
                      class=" color-option"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.cityId"
                  class="text-danger float-left small error-danger"
                  >{{ errors.cityId }}</span
                >
              </div>
            </div>
            <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Placa *</h6>
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.plate }"
                    v-model="dataUser.plate"
                    type="text"
                    class="form-control color-input"
                    aria-label="plate"
                    placeholder="Placa"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.plate"
                  class="text-danger float-left small error-danger"
                  >{{ errors.plate }}</span
                >
              </div>
            </div>
            <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Dirección *</h6>
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.address }"
                    v-model="dataUser.address"
                    type="text"
                    class="form-control color-input"
                    aria-label="address"
                    placeholder="Dirección"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.address"
                  class="text-danger float-left small error-danger"
                  >{{ errors.address }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Teléfono *</h6>
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.phone }"
                    type="text"
                    v-model="dataUser.phone"
                    class="form-control color-input"
                    aria-label="phone"
                    placeholder="Teléfono *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.phone"
                  class="text-danger float-left small error-danger"
                  >{{ errors.phone }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Email *</h6>
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.email }"
                    v-model="dataUser.email"
                    type="text"
                    class="form-control color-input"
                    aria-label="email"
                    placeholder="email *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.email"
                  class="text-danger float-left small error-danger"
                  >{{ errors.email }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Fecha de nacimiento *</h6>
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.birthdate }"
                    type="text"
                    v-model="dataUser.birthdate"
                    class="form-control"
                    placeholder="fecha de nacimiento *"
                    :min="minDate()"
                    :max="maxDate()"
                    onfocus="(this.type='date')"
                  />
                </div>
                <span
                  v-if="errors.birthdate"
                  class="text-danger float-left small error-danger"
                  >{{ errors.birthdate }}</span
                >
              </div>
            </div>
            <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Género *</h6>
                <div class="input-group mb-3 ">
                  <select
                    v-model="dataUser.gender_id"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.genderId }"
                    id="exampleFormControlSelect1"
                    placeholder="Genero *"
                  >
                    <option value="0" disabled selected>Género *</option>
                    <option
                      v-for="(item, i) in listGenders"
                      :key="'td' + i"
                      :value="item.id"
                      class="color-option"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.genderId"
                  class="text-danger float-left small error-danger"
                  >{{ errors.genderId }}</span
                >
              </div>
            </div>
            <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Marca de tu moto *</h6>
                <div class="input-group mb-3">
                  <select
                    v-model="dataUser.motorcycle_brands_id"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.motorcycleBrand }"
                    id="motorcycleBrand"
                  >
                    <option v-for="item in listBrands" :key="item.id" :value="item.id" class="color-option" >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <span
                    v-if="errors.motorcycleBrand"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleBrand }}</span
                >
              </div>
            </div>
            <div v-if="dataUser.motorcycle_brands_id == 44 && dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">¿Cúal? *</h6>
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.motorcycleBrandOther }"
                    v-model="dataUser.motorcycle_brand_other"
                    type="text"
                    class="form-control color-input"
                    aria-label="text"
                    placeholder="¿Cúal? (Escriba la marca de su moto) *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                    v-if="errors.motorcycleBrandOther"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleBrandOther }}</span
                >
              </div>
            </div>
            <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Cilindraje de tu moto *</h6>
                <div class="input-group mb-3">
                  <select
                      v-model="dataUser.motorcycle_cylinder_sizes_id"
                      class="form-control color-input select-input"
                      :class="{ 'is-danger': errors.motorcycleCylinder }"
                      id="motorcycleCylinder"
                  >
                    <option v-for="item in listCylinders" :key="item.id" :value="item.id" class="color-option" >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <span
                    v-if="errors.motorcycleCylinder"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleCylinder }}</span
                >
              </div>
            </div>
            <div v-if="dataUser.role_id == 5" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">Uso de tu moto *</h6>
                <div class="input-group mb-3">
                  <select
                      v-model="dataUser.motorcycle_uses_id"
                      class="form-control color-input select-input"
                      :class="{ 'is-danger': errors.motorcycleUse }"
                      id="motorcycleUse"
                  >
                    <option v-for="item in listUses" :key="item.id" :value="item.id" class="color-option" >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <span
                    v-if="errors.motorcycleUse"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleUse }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12"
              v-if="dataUser.motorcycle_uses_id == 4"
            >
              <div class="form-group">
                <h6 style="text-align:left; font-size:13px">¿Cúal? *</h6>
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.motorcycleUseOther }"
                    v-model="dataUser.motorcycle_use_other"
                    type="text"
                    class="form-control color-input"
                    aria-label="text"
                    placeholder="¿Cúal? (Escriba el uso de su moto) *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                    v-if="errors.motorcycleUseOther"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleUseOther }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
              <button
                :disabled="disableLoadingSend"
                type="button"
                @click="updateData()"
                class="btn btn-danger btn-sm btn-block btn-register"
                id="btn-register-id"
              >
                <span
                  v-if="disableLoadingSend"
                  class="spinner-border spinner-border-md"
                  role="status"
                  aria-hidden="true"
                ></span>
                <template v-else>ACTUALIZAR DATOS</template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "contentLanding",
  data() {
    return {
      listGenders: [],
      dataUser: [],
      data: {},
      userDataFlag: [],
      flag: false,
      datos: [],
      listBrands: [],
      listCylinders: [],
      listUses: [],
      disableLoadingSend: false,
      showProfiles: {
        classBiker: "btn-danger",
        classLubricator: "btn-danger",
        biker: true,
        lubricator: true,
      },
      listDocuments: [],
      listCities: [],
      listTypeDocuments: [],
      form: {
        distributorId: 0,
        state: 0,
        cityId: 0,
        documentType: 0,
        documentNumber: "",
        name: "",
        lastName: "",
        checkMail: false,
        phone: "",
        email: "",
        genderId: 0,
      },
      errors: {
        distributorId: false,
        state: false,
        cityId: false,
        documentType: false,
        documentNumber: false,
        name: false,
        lastName: false,
        phone: false,
        email: false,
        genderId: 0,
      },
      showCities: true,
      disableLoading: false,
      file: null,
      link: null,
      flagData: null,
    };
  },
  methods: {
    minDate() {
      const now = new Date();
      now.setFullYear(now.getFullYear() - 100);
      return now.toISOString().substr(0, 10);
    },
    maxDate(){
      const now = new Date();
      now.setFullYear(now.getFullYear() - 18);
      return now.toISOString().substr(0, 10);
    },
    getDataUser(){
      var app = this;
      axios
        .get("api/showUser")
        .then(function(res) {
          app.dataUser = res.data.User;
          // console.log('app.dataUser: ', JSON.stringify(app.dataUser));
          if(app.dataUser.role_id != 5 && app.dataUser.role_id != 4){
            app.$router.push({ name: "profileUser" });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getFlagUser(){
      axios
      .get("api/dataUser")
      .then((response) => {
        if(response.data.cod == 0){
          this.userDataFlag = response.data;
          // console.log('this.userDataFlag.data: ', JSON.stringify(this.userDataFlag.data));
          if(this.userDataFlag.data != null){
            if(this.userDataFlag.data[0].user_id == this.dataUser.id){
              this.$swal({
                icon: "info",
                title: "Oops...",
                text: "Ya actualizaste tus datos por este medio",
                confirmButtonText: 'Ok',
                confirmButtonColor: "#dc3545",
              }).then(() => {
                if(this.dataUser.role_id == 5){
                  this.$router.push({ name: "profileUser" });
                }
                else if(this.dataUser.role_id == 4){
                  this.$router.push({ name: "lubricatorProfile" });
                }
              });
              } else {
                this.updateData();
              }
          } else {
            this.updateData();
          }
        }
      })
      .catch(error => {
        // console.log(error);
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
    updateData(){
      this.data = {
        documentType: this.dataUser.document_type_id,
        documentNumber: this.dataUser.document_number,
        name: this.dataUser.name,
        lastName: this.dataUser.last_name,
        stateId: this.dataUser.state_id,
        cityId: this.dataUser.city_id,
        plate: this.dataUser.plate,
        address: this.dataUser.address,
        phone: this.dataUser.phone,
        email: this.dataUser.email,
        birthdate: this.dataUser.birthdate,
        genderId: this.dataUser.gender_id,
        motorcycleBrand: this.dataUser.motorcycle_brands_id,
        motorcycleBrandOther: this.dataUser.motorcycle_brand_other,
        motorcycleCylinder: this.dataUser.motorcycle_cylinder_sizes_id,
        motorcycleUse: this.dataUser.motorcycle_uses_id,
        motorcycleUseOther: this.dataUser.motorcycle_use_other,
        link: this.link,
        flagData: this.flagData,
      };
      // console.log('this.data ', JSON.stringify(this.data));
      this.disableLoadingSend = true;
      axios
        .put("api/updateDataUser", this.data)
        .then((res) => {
          if (res.data.cod == 0){
            this.$swal({
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
              confirmButtonText: 'Ok',
              confirmButtonColor: "#dc3545",
            }).then(() => {
              if(this.dataUser.role_id == 5){
                this.$router.push({ name: "profileUser" });
              }
              else if(this.dataUser.role_id == 4){
                this.$router.push({ name: "lubricatorProfile" });
              }
            });
            this.disableLoadingSend = false;
            this.getDataUser();
          } else {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "info",
              title: "Oops...",
              text: res.data.message,
            }).then(() => {
              if(this.dataUser.role_id == 5){
                this.$router.push({ name: "profileUser" });
              }
              else if(this.dataUser.role_id == 4){
                this.$router.push({ name: "lubricatorProfile" });
              }
            });
            this.disableLoadingSend = false;
          }
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "info",
            title: "Oops...",
            text: error.response.data.message,
          }).then(() => {
            if(this.dataUser.role_id == 5){
              this.$router.push({ name: "profileUser" });
            }
            else if(this.dataUser.role_id == 4){
              this.$router.push({ name: "lubricatorProfile" });
            }
          });
          this.disableLoadingSend = false;
        });
    },
    getGenders() {
      axios
        .get("api/getGenders")
        .then((res) => {
          if (res.data.cod == 0) {
            this.listGenders = res.data.data;
          }
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    getDocuments() {
      axios
        .get("api/files/active/" + 1)
        .then((res) => {
          if (res.data.cod == 0) {
            this.file = res.data.data[0].url;
          }
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    distributorList() {
      var app = this;
      axios
        .get("api/distributorList")
        .then(function(res) {
          if (res.data.cod == 0) {
            app.listDistributor = res.data.data;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    irCode() {
      let sesion = sessionStorage.getItem("token");
      if (sesion == "" || sesion == null) {
        this.$router.push({ name: "login" });
      } else {
        this.$router.push({ name: "homeUser" });
      }
    },
    getListStates() {
      var app = this;
      axios
        .get("api/getStates")
        .then(function(res) {
          app.listDocuments = res.data.states;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCities(stateId) {
      var app = this;
      var data = {
        stateId: stateId,
      };
      axios
        .post("api/showCity", data)
        .then(function(res) {
          app.listCities = res.data.cities;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getTypeDocuments() {
      var app = this;
      axios
        .get("api/documentTypeController")
        .then(function(res) {
          app.listTypeDocuments = res.data.TypeDocument;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    validEmail(email) {
      /* eslint-disable no-useless-escape */
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone(phone) {
      var re = /^[0-9]{7,10}$/;
      return re.test(phone);
    },
    validPassword(pass) {
      var re = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
      return re.test(pass);
    },
    getBrands(){
      axios
      .get("api/motorcycleBrands/get")
      .then((res) => {
        if (res.data.cod == 0) {
          this.listBrands = res.data.data;
        }
      })
      .catch((error) => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
    getMotorcycleCylinder(){
      axios
      .get("api/motorcycleCylinder/get")
      .then((res) => {
        if (res.data.cod == 0) {
          this.listCylinders = res.data.data;
        }
      })
      .catch((error) => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
    getMotorcycleUses(){
      axios
      .get("api/motorcycleUses/get")
      .then((res) => {
        if (res.data.cod == 0) {
          this.listUses = res.data.data;
        }
      })
      .catch((error) => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
  },
  watch: {
    "dataUser.state_id": function(n) {
      this.getCities(n);
      if (n == 0) {
        this.errors.state = "El departamento es requerido.";
      } else {
        this.errors.state = false;
      }
    },
    "dataUser.gender_id": function(n) {
      if (n != 0) {
        this.errors.genderId = false;
      } else {
        this.errors.genderId = "El género es requerido.";
      }
    },
    "dataUser.city_id": function(n) {
      if (n != 0) {
        this.errors.cityId = false;
      } else {
        this.errors.cityId = "La ciudad es requerida.";
      }
    },
    "dataUser.document_type_id": function(n) {
      if (n != 0) {
        this.errors.documentType = false;
      } else {
        this.errors.documentType = "El tipo de documento es requerido.";
      }
    },
    "dataUser.document_number": function(n) {
      if (n) {
        this.errors.documentNumber = false;
      } else {
        this.errors.documentNumber = "El número de documento es requerido.";
      }
    },
    "dataUser.name": function(n) {
      if (n) {
        this.errors.name = false;
      } else {
        this.errors.name = "Los nombres son requeridos.";
      }
    },
    "dataUser.last_name": function(n) {
      if (n) {
        this.errors.lastName = false;
      } else {
        this.errors.lastName = "Los apellido son requeridos.";
      }
    },
    "dataUser.phone": function(n) {
      if (!n) {
        this.errors.phone = "El teléfono es requerido.";
      } else if (!this.validPhone(n)) {
        this.errors.phone = "El teléfono es inválido.";
      } else {
        this.errors.phone = false;
      }
    },
    "dataUser.email": function(n) {
      if (!n) {
        this.errors.email = "El email es requerido.";
      } else if (!this.validEmail(n)) {
        this.errors.email = "El email es inválido.";
      } else {
        this.errors.email = false;
      }
    },
  },
  mounted(){
    this.getDataUser();
    this.getTypeDocuments();
    this.getDocuments();
    this.getGenders();
    this.getListStates();
    this.getBrands();
    this.getMotorcycleCylinder();
    this.getMotorcycleUses();
    this.distributorList();
    this.link = localStorage.getItem('link');
    this.flagData = localStorage.getItem('flagUpdateData');
  },
};
</script>

<style scope>
.content-register {
  padding-left: 5%;
  padding-top: 10%;
  padding-bottom: 10%;
  height: 100%;
}
.table-register {
  margin-left: 10%;
}
.small-register {
  font-family: "GothamBoldItalic", sans-serif !important;
}
.club {
  font-size: 55px;
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left;
}
.password-text {
  font-family: "GothamBoldItalic", sans-serif;
}
.ingresa {
  font-size: 18px;
  text-align: left;
  font-family: "GothamBookItalic", sans-serif;
}
.t-c {
  text-align: center;
}
#content1-register {
  background-size: cover;
  background-image: url("../../assets/img/03.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}
a.condiciones {
  text-align: left !important;
  cursor: pointer !important;
  color: white;
  border-bottom: 1px solid;
}
.font-none {
  font-family: "Arial", sans-serif;
}
.condiciones:hover {
  color: #b3b3b3 !important;
  /* border-bottom: 1px solid; */
}
.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0px 15px !important;
}
.color-select {
  font-size: 13px;
  height: 30px !important;
  position: relative;
  padding: 0px 15px !important;
}
.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.error-danger {
  text-align: left !important;
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}
.color-input::placeholder {
  color: white !important;
}
.color-option {
  color: black !important;
}
.color-option:active {
  background-color: crimson !important;
}
.icon-disable {
  color: #676565 !important;
}
.input-code:disabled {
  opacity: 0 !important;
  border-color: #000000 !important;
}
.small-info {
  text-align: center !important;
  color: #fff !important;
  font-size: 18px !important;
}
.icon::before {
  position: absolute;
  top: 25%;
  left: 5%;
}
input[type="date"]::-webkit-calendar-picker-indicator{
  cursor: pointer;
  filter: invert(0.9);
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .color-input {
    padding: 0px 15px !important;
  }
  .content-register {
    height: 100%;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .content-register {
    height: 100%;
  }
  .padding-t2 {
    padding-top: 13%;
    padding-bottom: 8%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .p-row {
    padding-bottom: 1% !important;
  }
  .table-register {
    margin-left: 0%;
  }
  .content-register {
    padding-left: 0%;
    padding-top: 50%;
    padding-bottom: 30%;
  }
  .club {
    font-size: 40px;
    text-align: left;
  }
  .ingresa {
    font-size: 18px;
    text-align: left;
  }
  .margin-btn {
    margin-bottom: 35%;
  }
}
</style>
